import { Outlet } from "react-router-dom";

const Medium = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Medium;
